export type T_CSKHConfig = {
  CSKH?: string
  CSKH_TELEGRAM?: string
  CSKH_LINE?: string
  CSKH_FACEBOOK?: string
  CSKH_X?: string
  CSKH_VIBER?: string
  CSKH_WHATSAPP?: string
  CSKH_SSQ?: string
  MAIN_CSKH?: string
  OFFICIAL_PAGE?: string // 落地页
  TELEGRAM_GROUP?: string // telegram 社群

  SHARE_GAME_URL?: string //邀请url
  SIGN_IN_BOT?: string //签到机器人

  SHARE_TELEGRAM?: string //邀请telegram

  LOGIN_TELEGRAM?: string //登陆telegram
  LOGIN_WHATSAPP?: string //登陆whatsapp

  HOME_TELEGRAM?: string //首页telegram
  HOME_FACEBOOK?: string //首页facebook
  HOME_WHATSAPP?: string //首页whatsapp

  REDEEM_TELEGRAM?: string //兑换码TELEGRAM
  REDEEM_FACEBOOK?: string //兑换码FACEBOOK
  REDEEM_WHATSAPP?: string //兑换码whatsapp

  HOME_FLOAT_WHATSAPP?: string //浮窗跳转whatsapp
  HOME_FLOAT_TELEGRAM?: string //浮窗跳转telegram

  SHARE_WHATSAPP?: string

  CSKH_AGENT?: string
}

let _config: T_CSKHConfig = {}

export const useCSKH = () => {
  const install = (config: T_CSKHConfig) => {
    if (!config) return
    _config = { ..._config, ...config }
  }

  /**
   * 跳转到代理的客服
   */
  const openAgentCSKH = () => {
    window.open(_config.CSKH_AGENT ?? '')
  }

  return { install, openAgentCSKH }
}
